import { getLogger } from 'Utils/logger';
import { updatePusherLogs } from 'Utils/pusherLogsUtil';

/**
 * Sets up event listeners to log app lifecycle events:
 * - App startup
 * - Internet connectivity changes
 * - Document visibility changes
 */
export const setupAppLifecycleLogging = () => {
  console.log('setupAppLifecycleLogging');
  const logger = getLogger();

  // Log app startup
  const startupMessage = `Pusher logs: App started;`;
  logger.info(startupMessage);

  // Log internet connectivity changes
  const handleOnline = () => {
    const message = `Pusher logs: Internet connection restored;`;
    logger.info(message);

    // Also update Pusher logs if needed
    updatePusherLogs({
      type: 'internet_connection',
      status: 'restored',
    }).catch(err => {
      logger.error('Failed to update Pusher logs for internet connection restored', err);
    });
  };

  const handleOffline = () => {
    const message = `Pusher logs: Internet connection lost;`;
    logger.info(message);

    // Also update Pusher logs if needed
    updatePusherLogs({
      type: 'internet_connection',
      status: 'lost',
    }).catch(err => {
      logger.error('Failed to update Pusher logs for internet connection lost', err);
    });
  };

  // Log document visibility changes
  const handleVisibilityChange = () => {
    if (document.hidden) {
      const message = `Pusher logs: Document lost focus;`;
      logger.info(message);

      // Also update Pusher logs if needed
      updatePusherLogs({
        type: 'document_focus',
        status: 'lost',
      }).catch(err => {
        logger.error('Failed to update Pusher logs for document focus lost', err);
      });
    } else {
      const message = `Pusher logs: Document regained focus;`;
      logger.info(message);

      // Also update Pusher logs if needed
      updatePusherLogs({
        type: 'document_focus',
        status: 'restored',
      }).catch(err => {
        logger.error('Failed to update Pusher logs for document focus restored', err);
      });
    }
  };

  // Add event listeners
  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);
  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Return cleanup function
  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};